import React from 'react';
import styled from 'styled-components';
import { Text } from '../../../components_new/common';
import Vivus from 'vivus';
import splashSquare from '../../../../images/banner/splash-square.jpg';
import splashImgWide from '../../../../images/banner/splash-wide.jpg';
import svgOverlayWide from '../../../../images/banner/svgOverlayWide.svg';

// SVG animations are done in rentall-common.css

export default class HomeTopBanner extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      currentIndex: 0,
      translateValue: 0,
      windowWidth: 0,
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentDidMount() {
    new Vivus(
      'svg-overlay',
      {
        file: svgOverlayWide,
        start: 'manual',
      },
      null
    );

    this.updateWindowDimensions();
    if (window && !this.props.fixedWidth) {
      window.addEventListener('resize', this.updateWindowDimensions);
    }
    if (this.props.fixedWidth) {
      this.setState({
        windowWidth: this.props.fixedWidth,
      });
    }
  }

  componentWillUnmount() {
    if (window) {
      window.removeEventListener('resize', this.updateWindowDimensions);
    }
  }

  updateWindowDimensions() {
    this.setState({
      windowWidth: window.innerWidth,
    });
  }

  render() {
    const props = this.props;
    return (
      <Banner>
        {props.renderHeader()}
        <BannerInner id="svg-overlay" />
        <BannerImage src={splashImgWide} />
        <BannerInnerSmall>
          <Text banner primaryDark bold mb={2}>
          Rent anything
          </Text>
          <Text align="right" grayDarkMedium textheader light>
          Download the app and
          </Text>
          <Text align="right" grayDarkMedium textheader light>
          start renting today. 
          </Text>
        
        </BannerInnerSmall>
      </Banner>
    );
  }
}

const Banner = styled.div`
  margin-top: 70px;
  max-height: 80vw;
  width: 100%;
  background-size: contain;
  background-repeat: no-repeat;
  position: relative;

  @media only screen and (min-width: 900px) {
    background-image: none;
  }

  @media only screen and (min-width: 1400px) {
    background-image: none;
  }

  @media only screen and (max-width: 900px) {
    background-size: cover;
    background-image: url('${splashSquare}');
    height: 80vw;
  }
`;

const BannerImage = styled.img`
  width: 100%;

  @media only screen and (max-width: 900px) {
    display: none;
  }
`;

const BannerInner = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0px;
  height: 100%;
  width: 100%;

  @media only screen and (max-width: 900px) {
    display: none;
  }
`;

const BannerInnerSmall = styled.div`
  position: absolute;
  right: 16px;
  top: 45px;
  display: flex;
  transform-origin: top right;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-end;
  transform: scale(1);

  @media only screen and (min-width: 500px) {
    right: 16px;
    top: 55px;
  }

  @media only screen and (min-width: 600px) {
    right: 32px;
    top: 60px;
  }

  @media only screen and (min-width: 650px) {
    right: 64px;
    top: 70px;
  }

  @media only screen and (min-width: 775px) {
    right: 106px;
    top: 80px;
  }

  @media only screen and (min-width: 900px) {
    background-color: white;
    padding: 24px;
  }

  @media only screen and (min-width: 1100px) {
    background-color: transparent;
    padding: 0px;
  }

  @media only screen and (min-width: 1024px) {
    right: 14%;
    top: 30%;
  }

  @media only screen and (max-width: 500px) {
    transform: scale(1);
  }

  @media only screen and (max-width: 450px) {
    transform: scale(0.8);
  }

  @media only screen and (max-width: 400px) {
    transform: scale(0.7);
  }

  @media only screen and (max-width: 350px) {
    transform: scale(0.6);
  }

  @media only screen and (max-width: 330px) {
    transform: scale(0.5);
  }
`;

const SearchWrapper = styled.div`
  justify-content: center;
  align-items: center;

  width: '100%';
  height: '100%';
  z-index: 5;
  position: 'relative';

  @media only screen and (max-width: 900px) {
    display: none;
  }
`;



// WEBPACK FOOTER //
// ./src/routes/presentation/Home/HomeTopBanner.js